// 날짜 포맷
const yyyyMM: 'yyyy-MM' = 'yyyy-MM' as const;
const yyyyMMdd: 'yyyy-MM-dd' = 'yyyy-MM-dd' as const;
const yyyyMMddHHmm: 'yyyy-MM-dd HH:mm' = 'yyyy-MM-dd HH:mm' as const;
const yyyyMMddHHmmss: 'yyyy-MM-dd HH:mm:ss' = 'yyyy-MM-dd HH:mm:ss' as const;

const BASE_DATE_FORMAT = yyyyMMdd;
const BASE_DATETIME_FORMAT = yyyyMMddHHmmss;

export const MG_FORMAT = {
  DATE_FORMAT: BASE_DATE_FORMAT,
  DATETIME_FORMAT: BASE_DATETIME_FORMAT,

  ym: yyyyMM,
  ymd: yyyyMMdd,
  ymdhm: yyyyMMddHHmm,
  ymdhms: yyyyMMddHHmmss,
};
